const getAxiosConfig = () => ({
  isJsonMime: () => false,
  basePath: process?.env?.REACT_APP_URL || "",
  token: localStorage.getItem("token"),
});

export default getAxiosConfig;
